import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';
import util from '@utils/util';

import './Filter.less';


export class Filter extends CommonComponent {
  confirm = '';

  constructor(props) {
    super(props);
    this.options = this.props.options;

    this.state = {
      filterShow: false,
      category: [],
      chooseCateId: '',
      location: '',
      myAddress: false,
      myAddressList: [],
      myAddressIndex: '',
      chooseArea: false,
      areaList: [],
      province: {},
      city: {},
      town: {},
      areaType: 'province', // type值为province、city、town
      areaId: '',
      leastPrice: '',
      mostPrice: '',
      currentRegionId: '',
      form: 'goods',
      goodsType: 0,
      hasTabbar: false
    };
  }

  // 展示弹窗。小程序里面通过data里面的数据控制展示，这里是调用这个方法。参数和小程序一直
  show = (options) => {
    let {
      filterShow,
      chooseCateId,
      form,
      confirm
    } = options;

    if(filterShow && filterShow === true){
      let newdata = {};
      newdata.filterShow = true
      this.getCategory();
      newdata.hasTabbar = app.isTabBarPage();

      if(chooseCateId){
        newdata.chooseCateId = chooseCateId;
      }
      if(form){
        newdata.form = form || 'goods';
        newdata.goodsType = util.getGoodsTypeByForm(form);
      }
      this.setData(newdata);
      if(confirm){
        this.confirm = confirm;
      }
    }
  }

  // 获取定位
  getLocation = () => {
    let that = this;
    app.getLocation({
      success: function (res) {

        if(!res.longitude){
          return;
        }
        app.sendRequest({
          url: '/index.php?r=Map/getAreaInfoByLatAndLng',
          data: {
            longitude: res.longitude,
            latitude: res.latitude
          },
          success: function (data) {
            let province = data.data.address_component.province;
            let city = data.data.address_component.city;
            let district = data.data.address_component.district;

            that.setData({
              location: province + city + district,
              currentRegionId: data.data.region_id
            });
          }
        });

        that.setData({
          longitude: res.longitude,
          latitude: res.latitude
        });
      },
      fail: function (res) {
        console.log(res);
      }
    });
  }

  // 获取商品分类
  hasGetCateGory = false;
  getCategory = () => {
    let that = this;
    if (that.hasGetCateGory){
      return;
    }
    let pageInstance  = app.getAppCurrentPage();
    app.sendRequest({
      url: '/index.php?r=appData/listCategory',
      data: {
        form: 'goods',
        goods_type: that.data.goodsType
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let data = res.data;
        let newdata = {};
        that.hasGetCateGory = true;

        for(let i = 0; i < data.length; i++){
          let subclass = data[i].subclass;
          if (subclass && subclass.length > 0){
            let h = Math.ceil((subclass.length + 1) / 2) * 99 + 15;
            data[i].height = h;
            if(i == 0 || i == 1){
              data[i].isOpen = true;
            }
          }
        }

        newdata['category'] = data;
        that.setData(newdata);
      }
    });
  }

  // 选择分类
  chooseCategory = (e) => {
    let id = e.currentTarget.dataset.id;
    let detail = {
      leastPrice: this.data.leastPrice,
      mostPrice: this.data.mostPrice,
      chooseCateId : id,
      currentRegionId: this.data.currentRegionId
    }
    this.setData(detail);
    this.confirm && this.confirm({detail: detail});
  }

  // 展开、隐藏二级分类
  openCate = (e) => {
    let index = e.currentTarget.dataset.index;
    let newdata = {};

    newdata['category[' + index + '].isOpen'] = !this.data.category[index].isOpen;
    this.setData(newdata);
  }

  // 展示我的地址
  showMyAddress = () => {
    this.setData({
      myAddress: true
    });
    this.getMyAddress();
  }

  // 隐藏我的地址
  hideMyAddress = () => {
    this.setData({
      myAddress: false
    });
  }

  // 获取我的地址
  getMyAddress = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=AppShop/addressList',
      data: {},
      success: function (res) {
        let list = res.data;
        let newdata = {};

        newdata['myAddressList'] = list;
        that.setData(newdata);
      }
    });
  }

  // 选择我的地址
  chooseMyAddress = (e) => {
    let index = e.currentTarget.dataset.index;
    let ad = this.data.myAddressList[index];
    let region = e.currentTarget.dataset.region;

    this.setData({
      myAddressIndex: index,
      myAddress: false,
      location: ad.address_info.province.text + ad.address_info.city.text + ad.address_info.district.text,
      currentRegionId: region
    });
  }

  // 展示选择地区
  showChooseArea = () => {
    this.setData({
      chooseArea: true,
      areaType : 'province',
      province: {},
      city: {},
      town: {}
    });
    this.getArea();
  }

  // 隐藏选择地区
  hideChooseArea = () => {
    this.setData({
      chooseArea: false
    });
  }

  // 获取地区
  allAreaList = [];
  getArea = () => {
    let that = this;

    app.sendRequest({
      url: '/index.php?r=AppShop/getAllRegionInfo',
      data: {},
      success: function (res) {
        let list = res.data;
        let provinceArr = [];
        let newdata = {};

        that.allAreaList = list;

        newdata['areaList'] = list;

        that.setData(newdata);
      }
    });
  }

  // 选择地区
  chooseArea = (e) => {
    let newdata = {};
    let that = this;
    let id = e.currentTarget.dataset.id;
    let areaType = that.data.areaType;
    let areaList = that.data.areaList;

    if (areaType == 'province'){
      for (let i in areaList) {
        if(id == areaList[i].id){
          newdata[that.data.areaType] = areaList[i];
          newdata['areaList'] = areaList[i].cities;
        }
      }
      newdata['areaType'] = 'city';
    } else if (areaType == 'city'){
      for (let i in areaList) {
        if (id == areaList[i].id) {
          newdata[that.data.areaType] = areaList[i];
          newdata['areaList'] = areaList[i].towns;
        }
      }
      newdata['areaType'] = 'town'; 
    } else if (areaType == 'town'){
      for (let i in areaList) {
        if (id == areaList[i].id) {
          newdata[that.data.areaType] = areaList[i];
          newdata['currentRegionId'] = id;
        }
      }
      newdata['location'] = that.data.province.name + that.data.city.name + newdata.town.name;
      newdata['myAddress'] = false;
      newdata['chooseArea'] = false;
    }
    newdata['areaId'] = id;
    this.setData(newdata);
  }

  // 重设省份
  resetProvince = () => {
    let that = this;
    that.setData({
      areaType: 'province',
      areaId: '',
      areaList: that.allAreaList,
      province: {},
      city: {},
      town: {}
    });
  }

  // 重设城市
  resetCity = () => {
    let that = this;
    that.setData({
      areaType: 'city',
      areaId: '',
      areaList: that.data.province.cities,
      city: {},
      town: {}
    });
  }

  // 隐藏组件
  filterHide = () => {
    this.setData({
      filterShow: false,
      myAddress: false,
      chooseArea: false
    });
  }

  // 最低价格输入框
  leastPriceInput = (e) => {
    this.setData({
      leastPrice: e.target.value
    })
  }

  // 最高价格输入框
  mostPriceInput = (e) => {
    this.setData({
      mostPrice: e.target.value
    })
  }

  // 重置
  filterReset = () => {
    let detail = {
      leastPrice: '',
      mostPrice: '',
      chooseCateId: '',
      location: '',
      currentRegionId: ''
    }
    this.setData(detail);
    this.confirm && this.confirm({detail: detail});
  }

  // 确定
  filterConfirm = () => {
    let that = this;
    if (that.data.leastPrice || that.data.mostPrice){
      if ((!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(that.data.leastPrice)) || (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(that.data.mostPrice))){
        app.showModal({
          content: '价格区间填写有误'
        });
        return;
      }
      if (+that.data.leastPrice > +that.data.mostPrice){
        app.showModal({
          content: '价格区间中设置的最大值需大于最小值'
        });
        return;
      }
    }
    let detail = {
      leastPrice: that.data.leastPrice || '',
      mostPrice: that.data.mostPrice || '',
      chooseCateId: that.data.chooseCateId,
      currentRegionId: that.data.currentRegionId
    }
    that.setData(detail);
    this.confirm && this.confirm({detail: detail});
    that.filterHide();
  }
  
  
  render() {
    const {
      filterShow,
      topNavBarHeight,
      category,
      chooseCateId,
      leastPrice,
      mostPrice,
      location,
      myAddress,
      myAddressList,
      myAddressIndex,
      chooseArea,
      areaType,
      province,
      city,
      town,
      areaList,
      areaId,
      hasTabbar
    } = this.state;

    if(!filterShow){
      return null;
    }
    return (
      <div className="common-component filter filter-wrap" style={{top: topNavBarHeight + 'px', bottom: hasTabbar ? '49px' : '0px'}}>
        <div className="filter-bg" onClick={this.filterHide}></div>
        <div className="filter-inner active">
          <div className="filter-cate">
            {
              category.map((item, index) => (
                item.subclass && item.subclass.length > 0 ? (
                  <div className="filter-box" key={item.id}>
                    <div className="filter-box-head clearfix" data-id={item.id} data-index={index} onClick={this.openCate}>
                      <div className="filter-box-title">{item.name}</div>
                      {
                        item.isOpen ? 
                        <div className="filter-box-all">收起 <label className="ico-moon icon-uparrow"></label></div>
                        :
                        <div className="filter-box-all">展开 <label className="ico-moon icon-downarrow"></label></div>
                      }
                    </div>
                    <div className="filter-box-content cate-content" style={item.isOpen ? {height: (item.height / 100) + 'rem'} : {}}>
                      <div className={`filter-box-item ${chooseCateId == item.id ? 'active' : ''}`} data-id={item.id} onClick={this.chooseCategory}><label className="filter-subcate-text filter-subcate-noimg">全部</label></div>
                      {
                        item.subclass.map((subclass) => (
                          <React.Fragment key={subclass.id}>
                            {
                              subclass.logo ? 
                              <div className={`filter-box-item ${chooseCateId == subclass.id ? 'active' : ''}`} data-id={subclass.id} onClick={this.chooseCategory}><label className="filter-subcate-text">{subclass.name}</label><img className="filter-subcate-img" src={subclass.logo} mode="aspectFill" /></div>
                              :
                              <div className={`filter-box-item ${chooseCateId == subclass.id ? 'active' : ''}`} data-id={subclass.id} onClick={this.chooseCategory}><label className="filter-subcate-text filter-subcate-noimg">{subclass.name}</label></div>
                            }
                          </React.Fragment>
                        ))
                      }
                    </div>
                  </div>
                ) : (
                  <div className="filter-box" key={item.id}>
                    <div className={`filter-box-head clearfix ${chooseCateId == item.id ? 'active' : ''}`} data-id={item.id} onClick={this.chooseCategory}>
                      <div className="filter-box-title">{item.name}</div>
                      <div className="filter-box-all">查看全部 <label className="ico-moon icon-rightarrow"></label></div>
                      <div className="filter-head-line"></div>
                    </div>
                  </div>
                )
              ))
            }
            <div className="filter-box">
              <div className="filter-box-head">
                <div className="filter-box-title">价格区间（元）</div>
              </div>
              <div className="filter-box-content">
                <input className="filter-price-input" type="number" placeholder="最低价" value={leastPrice} onInput={this.leastPriceInput} onChange={() => {}} /><label className="filter-price-line">-</label><input className="filter-price-input" type="number" step="0.1" placeholder="最高价" value={mostPrice} onInput={this.mostPriceInput} onChange={() => {}}/>
              </div>
            </div>
            <div className="filter-box">
              <div className="filter-box-head">
                <div className="filter-box-title">城市选择</div>
              </div>
              <div className="filter-box-content">
                <div className={`filter-address ${location ? 'active' : ''}`} onClick={this.showMyAddress}><label className="filter-address-icon ico-moon icon-fesadress"></label>{location || '无'}</div>
                <div className="filter-location" onClick={this.getLocation}><label className="filter-location-icon ico-moon icon-fesadress"></label>定位</div>
              </div>
            </div>
          </div>
          <div className="filter-bottom">
            <div className="filter-reset" onClick={this.filterReset}>重置</div>
            <div className="filter-confirm" onClick={this.filterConfirm}>确定</div>
          </div>
        </div>
        <div className={`filter-inner filter-myaddress ${myAddress ? 'active' : ''}`}>
          <div className="filter-inner-head"><label className="filter-inner-head-icon ico-moon icon-leftarrow" onClick={this.hideMyAddress}></label>选择地址</div>
          <div className="filter-myaddress-list">
            {
              myAddressList.map((item, index) => (
                <div key={item.id} className={`filter-myaddress-item ${myAddressIndex === index ? 'active' : ''}`} data-id={item.id} data-index={index} data-region={item.address_info.district.id} onClick={this.chooseMyAddress}><label className="filter-myaddress-icon ico-moon icon-community-location"></label><span className="filter-myaddress-text">{item.address_info.province.text + item.address_info.city.text + item.address_info.district.text + (item.detail_address || '')}</span><label className="filter-myaddress-icon filter-myaddress-gou ico-moon icon-gou"></label></div>
              ))
            }
          </div>
          <div className="filter-bottom">
            <div className="filter-confirm" onClick={this.showChooseArea}>选择其他地址</div>
          </div>
        </div>
        <div className={`filter-inner filter-area ${chooseArea ? 'active' : ''}`}>
          <div className="filter-inner-head"><label className="filter-inner-head-icon ico-moon icon-leftarrow" onClick={this.hideChooseArea}></label>选择地址</div>
          <div className="filter-choose-area">
            <div className={`filter-choose-item ${areaType == 'province' ? 'active' : ''}`} onClick={this.resetProvince}>{province.name || '请选择省'}</div>{city.name || areaType == 'city' && <div className={`filter-choose-item ${areaType == 'city' ? 'active' : ''}`} onClick={this.resetCity}>{city.name || '请选择市'}</div>}{town.name || areaType == 'town' && <div className={`filter-choose-item ${areaType == 'town' ? 'active' : ''}`}>{town.name || '请选择区'}</div>}
          </div>
          <div className="filter-area-list">
            { 
              Object.keys(areaList).map((objkey) => (
                <div className={`filter-area-item ${areaId == areaList[objkey].id ? 'active' : ''}`} key={areaList[objkey].id} data-id={areaList[objkey].id} onClick={this.chooseArea}><span className="filter-area-text">{areaList[objkey].name}</span><label className="filter-area-gou ico-moon icon-gou"></label></div>
              ))
            }
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/filter/Filter.jsx